import { Components, Theme } from '@mui/material';

export const getListComponents = (
  theme: Theme,
): Pick<
  Components<Theme>,
  | 'MuiList'
  | 'MuiListItemButton'
  | 'MuiListItemIcon'
  | 'MuiListItemText'
  | 'MuiListSubheader'
> => ({
  MuiList: {
    styleOverrides: {
      root: ({ theme }) => ({
        width: '100%',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.lelySpacing.XS,
      }),
    },
  },

  MuiListItemButton: {
    styleOverrides: {
      root: {
        fontFamily: theme.lelyFontFamily.UBUNTU,
        padding: `${theme.lelySpacing.SM} ${theme.lelySpacing.MD}`,
        borderRadius: theme.shape.borderRadius,

        '&:hover': {
          backgroundColor: theme.palette.background.secondaryHover,
        },
      },
    },
  },

  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 0,
      },
    },
  },

  MuiListItemText: {
    styleOverrides: {
      root: {
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  MuiListSubheader: {
    styleOverrides: {
      root: {
        paddingLeft: theme.lelySpacing.MD,
        lineHeight: 'unset',
        fontWeight: 500,
        color: theme.palette.text.secondary,
      },
    },
  },
});
